import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import DashboardLayout from "@/components/DashboardLayout";
import Landing from "@/pages/Landing";
import { Login, Signup } from "@/pages/Auth";
import DailyRounds from "@/pages/DailyRounds";
import WeeklyTeasing from "@/pages/WeeklyTeasing";
import Mares from "@/pages/Mares";
import MareHistory from "@/pages/MareHistory";
import Foals from "@/pages/Foals";
import Settings from "@/pages/Settings";
import AdminConsole from "@/pages/AdminConsole";
import VetFarms from "@/pages/VetFarms";
import VetSchedule from "@/pages/VetSchedule";
import { useAuth } from "@/context/AuthContext";

function DashboardIndex() {
  const { isVet } = useAuth();
  return <Navigate to={isVet ? "/dashboard/schedule" : "/dashboard/daily"} replace />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-center" richColors />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route element={<ProtectedRoute />}>
              <Route path="/dashboard" element={<DashboardLayout />}>
                <Route index element={<DashboardIndex />} />
                <Route path="daily" element={<DailyRounds />} />
                <Route path="teasing" element={<WeeklyTeasing />} />
                <Route path="mares" element={<Mares />} />
                <Route path="history" element={<MareHistory />} />
                <Route path="foals" element={<Foals />} />
                <Route path="schedule" element={<VetSchedule />} />
                <Route path="farms" element={<VetFarms />} />
                <Route path="settings" element={<Settings />} />
                <Route path="admin" element={<AdminConsole />} />
              </Route>
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
